import { Mutation } from "../types";

export default {
  [Mutation.LOGIN](state, payload) {
    localStorage.setItem("token", payload.token);
    localStorage.setItem("user", JSON.stringify(payload.user));
    state.token = payload.token;
    state.user = payload.user;
  },
  [Mutation.LOGOUT](state) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    state.token = "";
    state.user = "";
  }
};
